module.exports = __webpack_public_path__ + "img/1_015.0ac1f7e8.jpg";